interface GenericErrorValue {
  error: string;
}

export interface DaccachError {
  error: GenericErrorValue;
}

export function DaccachErrorActions() {
  function createError(error: string): DaccachError {
    return {
      error: {
        error: error,
      },
    };
  }

  function extractFormError(formError: string): string {
    const error: { message: string; errors: Record<string, string[]> } =
      JSON.parse(JSON.stringify(formError));
    return Object.values(error.errors)[0]?.[0] ?? "";
  }

  return {
    createError,
    extractFormError,
  };
}
